module.exports = require(40).PassThrough
